export const CONDO_NAME = { en: 'Condo Name', th: 'คอนโด' }

export const DISTANCE = { en: 'Distance (m)', th: 'ระยะทาง (ม.)' }

export const PRICE = { en: 'Price', th: 'ราคาเช่า' }

export const RATING = { en: 'Rating', th: 'เรตติ้ง' }

export const SCORE = { en: 'Score', th: 'คะแนน' }
